import { ANFRAGE_STATES } from '../../types/index';
import GenericStateBadge from '../status/GenericStateBadge';

export default function AnfragenStateBadge({
  status,
  small,
  statesMap,
}: {
  status: string;
  small?: boolean;
  statesMap?: Record<string, { label: string; color: string }>;
}) {
  return <GenericStateBadge value={status} statesMap={statesMap ?? ANFRAGE_STATES} small={small} />;
}
